export default "{\n    \"sendingText\": \"Envoi en cours\"\n}\n"